import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";

interface Company {
  id: string;
  name: string;
  email: string;
  phone: string;
  subscription_status: string;
  subscription_end: string;
  subscription_price: number;
  status: 'active' | 'inactive' | 'suspended';
  total_users: number;
  total_properties: number;
  created_at: string;
}

interface CompaniesTableProps {
  companies: Company[];
  onSuspendCompany: (id: string) => void;
}

export function CompaniesTable({ companies, onSuspendCompany }: CompaniesTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Imobiliária</TableHead>
          <TableHead>Contato</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Vencimento</TableHead>
          <TableHead>Mensalidade</TableHead>
          <TableHead>Usuários</TableHead>
          <TableHead>Imóveis</TableHead>
          <TableHead>Ações</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {companies.map((company) => (
          <TableRow key={company.id}>
            <TableCell>
              <div>
                <p className="font-medium">{company.name}</p>
                <p className="text-sm text-muted-foreground">
                  Desde {format(new Date(company.created_at), 'dd/MM/yyyy')}
                </p>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <p className="text-sm">{company.email}</p>
                <p className="text-sm text-muted-foreground">{company.phone}</p>
              </div>
            </TableCell>
            <TableCell>
              <span className={`px-2 py-1 rounded-full text-xs ${
                company.status === "active" 
                  ? "bg-green-100 text-green-800" 
                  : company.status === "inactive"
                  ? "bg-gray-100 text-gray-800"
                  : "bg-red-100 text-red-800"
              }`}>
                {company.status === "active" ? "Ativa" : 
                 company.status === "inactive" ? "Inativa" : "Suspensa"}
              </span>
            </TableCell>
            <TableCell>
              {format(new Date(company.subscription_end), 'dd/MM/yyyy')}
            </TableCell>
            <TableCell>
              R$ {company.subscription_price?.toLocaleString('pt-BR')}
            </TableCell>
            <TableCell>{company.total_users}</TableCell>
            <TableCell>{company.total_properties}</TableCell>
            <TableCell>
              <Button 
                variant="destructive" 
                size="sm"
                onClick={() => onSuspendCompany(company.id)}
              >
                Suspender
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}